export default {"src":"/_next/static/media/radio-selected-icon.5c3ed063.svg","height":18,"width":18};